var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container search" },
    [
      _c("page-head", { attrs: { title: _vm.title } }),
      _vm.PRODUCTS.length
        ? _c("products-list")
        : _c(
            "page-info",
            {
              staticClass: "page-info offset-page-info",
              attrs: { title: "Товары не найдены" }
            },
            [
              _vm._v("\n    Попробуйте ввести другой\n    "),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$f.toggleSearch($event)
                    }
                  }
                },
                [_vm._v("\n      поисковый запрос\n    ")]
              ),
              _vm._v("\n    или посмотрите каталог по разделам\n  ")
            ]
          ),
      !_vm.PRODUCTS.length
        ? _c("product-gallery-slot", {
            staticClass: "offset-recommendation-gallery",
            attrs: { "with-category": false, "slot-name": "popular_main" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }